"use client"
import clsx from "clsx"

export function LogoSava() {
	return (
		<div className="relative flex flex-col justify-center items-center">
			<div className="flex justify-center items-baseline">
				<div
					className={clsx("font-extrabold text-center leading-relaxed text-transparent bg-clip-text bg-gradient-to-br from-0% to-100% from-gray-900 to-red-600 text-7xl")}
				>
					S
				</div>
				<div
					className={clsx("font-bold text-center -ml-1.5 leading-relaxed text-transparent bg-clip-text bg-gradient-to-br from-0% to-60% from-gray-900 to-red-600 text-6xl")}
					style={{ letterSpacing: -2 }}
				>
					ava
				</div>
			</div>
			<div className={clsx("inline-flex font-semibold items-center justify-center text-white/80 bg-red-600 rounded-tl-[2px] rounded-br-[2px] text-[7px] px-[6px] py-[1px] -mt-[26px] ml-[8px]")}>
				Ny Sakaizan&apos;ny Vahoaka
			</div>
		</div>
	)
}

const gateway = process.env.NEXT_PUBLIC_GATEWAY

export function handleGoogleSignin(role: "admin" | "operator") {
  const clientId = "8346063876-t91hmjviljpfg65re9s0f6l49u9h8h7n.apps.googleusercontent.com"
  const redirectUri = `${gateway || "http://localhost:3000"}/auth/signin/google?role=${role}`
  const scope = "profile email"
  const responseType = "code"
  window.location.href = `https://accounts.google.com/o/oauth2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=${responseType}&scope=${scope}`
}